import { useState } from "react";

const FiltrosBusqueda = ({ 
  filterText, 
  onFilterChange, 
  eventoOptions,
  selectedEventos,
  onToggleEvento,
  onClearEventos,
  activeTab, 
  onTabChange,
  estadoSeleccionado,
  onEstadoChange,
  estados,
  activoFiltro,
  onActivoFiltroChange
}) => {
  const [eventosAbierto, setEventosAbierto] = useState(false);

  return (
    <>
      {/* Buscador */}
      <div className="listado-filtros__busqueda">
        <input
          type="text"
          placeholder="Buscar en la tabla"
          value={filterText}
          onChange={(e) => onFilterChange(e.target.value)}
          className="listado-filtros__input"
        />
        <button
          type="button"
          onClick={() => setEventosAbierto((prev) => !prev)}
          className={`listado-filtros__boton-eventos ${eventosAbierto ? "is-active" : ""}`}
        >
          {eventosAbierto ? "Ocultar" : "Mostrar"} filtro por eventos
        </button>
      </div>

      {eventosAbierto && (
        <div
          style={{
            border: "1px solid #d1d5db",
            borderRadius: "12px",
            padding: "0.75rem",
            marginBottom: "0.75rem",
            backgroundColor: "#f9fafb"
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
            <strong style={{ fontSize: "0.9rem" }}>Eventos</strong>
            <button
              type="button"
              onClick={onClearEventos}
              style={{
                border: "none",
                background: "transparent",
                color: "#2563eb",
                cursor: "pointer",
                fontSize: "0.85rem"
              }}
            >
              Limpiar
            </button>
          </div>

          {eventoOptions.length === 0 ? (
            <span style={{ color: "#6b7280", fontSize: "0.85rem" }}>
              No hay eventos cargados para filtrar.
            </span>
          ) : (
            <div style={{ maxHeight: "160px", overflowY: "auto", display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "0.35rem 0.75rem" }}>
              {eventoOptions.map((evento) => (
                <label key={evento} style={{ display: "flex", alignItems: "center", gap: "0.4rem", fontSize: "0.85rem", cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={selectedEventos.includes(evento)}
                    onChange={() => onToggleEvento(evento)}
                  />
                  <span>{evento}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Tabs y filtros */}
      <div
        className="listado-filtros__barra"
      >
        {["Todos", "Casos", "Contactos"].map((tab) => (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            style={{
              backgroundColor: activeTab === tab ? "#ccc" : "#f0f0f0",
              border: "none",
              padding: "0.32rem 0.75rem",
              borderRadius: "35px",
              cursor: "pointer",
              fontSize: "0.85rem",
            }}
          >
            {tab}
          </button>
        ))}

        <select
          className="input"
          value={estadoSeleccionado}
          onChange={(e) => onEstadoChange(e.target.value)}
          style={{
            borderRadius: "35px",
            padding: "0.25rem 0.75rem",
            fontSize: "0.85rem",
            width: "120px",
            height: "30px"
          }}
        >
          <option value="">Estados</option>
          {estados.map((e) => (
            <option key={e.IdEstado} value={e.IdEstado}>
              {e.Nombre}
            </option>
          ))}
        </select>

        <div className="listado-filtros__activos">
          {["Todos", "Activos", "Inactivos"].map((filtro) => (
            <button
              key={filtro}
              onClick={() => onActivoFiltroChange(filtro)}
              style={{
                backgroundColor: activoFiltro === filtro ? "#aaa" : "#e0e0e0",
                border: "none",
                padding: "0.32rem 0.75rem",
                borderRadius: "35px",
                cursor: "pointer",
                fontSize: "0.85rem",
              }}
            >
              {filtro}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default FiltrosBusqueda;
